import { apiClient } from '../apiClient';
import { InvoiceNotificationSetting, InvoiceNotificationSettingResponse } from './types';

export const upsertInvoiceNotificationSetting = (setting: InvoiceNotificationSetting) => {
  return apiClient.request<InvoiceNotificationSettingResponse>(
    'POST',
    `/invoice-notification-setting`,
    setting,
  );
};
